import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { useLayout } from "@/providers";
import { PromoListings } from "./PromoListings";
import { usePermissions } from "@/hooks/usePermissions";

const PromoManagement = () => {
  const { currentLayout } = useLayout();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const handleNavigateToCreate = () => {
    navigate("/promo-management/create");
  };

  return (
    <Fragment>
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="promo-management-heading" />
              <ToolbarDescription>
                You can manage your promo codes here.
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              {hasPermission("coupon_management_create") && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={handleNavigateToCreate}
                  aria-label="Add new promo code"
                >
                  Add New Promo Code
                </button>
              )}
            </ToolbarActions>
          </Toolbar>
        </Container>
      )}
      <Container>
        <PromoListings />
      </Container>
    </Fragment>
  );
};

export { PromoManagement };
